(function () {
  const money = c => new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(c / 100);
  const esc = v => String(v ?? "").replace(/[&<>"']/g, ch => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[ch]));
  const isDefault = t => !t || t === "Default Title" || t === "Default";

  function init(root) {
    if (root.dataset.ewpReady === "true") return;
    root.dataset.ewpReady = "true";
    let data;
    try { data = JSON.parse(root.querySelector("[data-ewp-data]").textContent); }
    catch (e) { console.error("Wing package data could not load", e); return; }
    const S = data.settings;
    const clean = list => list.filter(p => p.variants.length > 0);
    const wings = clean(data.wings);
    const acc = clean(data.accessories);
    const STEPS = [
      { key: "wing1", label: S.labels[0], sub: S.subs[0], badge: ["req", "Required"], items: wings },
      { key: "wing2", label: S.labels[1], sub: S.subs[1], badge: ["deal", money(S.secondOff) .replace(".00", "") + " off"], items: wings, optional: true },
      { key: "pump", label: S.labels[2], sub: S.subs[2], badge: ["deal", "Up to " + S.pumpPct + "% off"], items: acc.filter(p => p.group === "pump"), optional: true, contain: true },
      { key: "harness", label: S.labels[3], sub: S.subs[3], badge: S.harnessFree ? ["deal", "Free with 2 wings"] : ["opt", "Optional"], items: acc.filter(p => p.group === "harness"), optional: true, contain: true },
      { key: "leash", label: S.labels[4], sub: S.subs[4], badge: ["deal", S.leashPct + "% off"], items: acc.filter(p => p.group === "leash"), optional: true, contain: true }
    ];
    const state = { wing1: null, wing2: null, pump: null, harness: null, leash: null };
    let adding = false;
    const q = s => root.querySelector(s);

    function pct(step, p) {
      if (p.pct !== null && p.pct !== undefined && p.pct !== "") return Number(p.pct);
      if (step.key === "pump") return S.pumpPct;
      if (step.key === "leash") return S.leashPct;
      return 0;
    }
    function pkgPrice(step, p, v) {
      if (!state.wing1) return v.price;
      if (step.key === "wing2") return Math.max(0, v.price - S.secondOff);
      if (step.key === "harness" && S.harnessFree && state.wing2) return 0;
      const d = pct(step, p);
      return d > 0 ? Math.round(v.price * (1 - d / 100)) : v.price;
    }
    function discLabel(step, p) {
      if (step.key === "wing2") return money(S.secondOff) + " second-wing discount";
      if (step.key === "harness") return "Free with two wings";
      return pct(step, p) + "% package discount";
    }
    const getSel = step => {
      const st = state[step.key]; if (!st) return null;
      const p = step.items[st.i]; return p ? { p, v: p.variants[st.v] } : null;
    };

    function render() {
      const wrap = q("[data-ewp-steps]");
      wrap.innerHTML = STEPS.map((s, si) => {
        const done = !!state[s.key];
        let body;
        if (s.key !== "wing1" && !state.wing1) {
          body = `<div class="ewp-locked">Choose your first wing in step 1 to unlock this step.</div>`;
        } else {
          let note = "";
          if (s.key === "wing2") note = `Add any other wing below for ${money(S.secondOff)} off.`;
          if (s.key === "pump") note = `Pump prices below include your package discount.`;
          if (s.key === "leash") note = `Leash prices below include ${S.leashPct}% off.`;
          if (s.key === "harness" && S.harnessFree) note = state.wing2 ? "You have two wings in your package, so this harness is free." : "Add a second wing in step 2 and this harness is free.";
          const cards = s.items.map((p, pi) => {
            const st = state[s.key];
            const sel = st && st.i === pi;
            const taken = s.key === "wing2" && state.wing1 && wings[state.wing1.i].id === p.id;
            const v = p.variants[sel ? st.v : 0];
            const pk = pkgPrice(s, p, v);
            const was = Math.max(v.compareAt || 0, v.price);
            const hasVar = p.variants.length > 1 || !isDefault(v.title);
            const saved = was - pk;
            const priceHtml = `<span class="now">${pk === 0 ? "FREE" : money(pk)}</span>${was > pk ? `<span class="was">${money(was)}</span>` : ""}` +
              (saved > 0 ? `<span class="ewp-save">Save ${money(saved)}${was > 0 ? " (" + Math.round(saved / was * 100) + "%)" : ""}</span>` : "") +
              (was > v.price && pk < v.price ? `<span class="ewp-split">Sale ${money(v.price)} + package ${pk === 0 ? "free" : "−" + money(v.price - pk)}</span>` : "");
            return `<div class="ewp-card${sel ? " is-selected" : ""}${taken ? " is-disabled" : ""}" role="button" tabindex="${taken ? -1 : 0}" aria-pressed="${!!sel}" data-step="${si}" data-i="${pi}">
              <div class="ewp-ph${s.contain ? " contain" : ""}">${p.image ? `<img loading="lazy" src="${esc(p.image)}" alt="${esc(p.title)} at Elite Watersports">` : ""}</div>
              ${taken ? '<span class="ewp-ribbon">In step 1</span>' : ""}
              <span class="ewp-check">✓</span>
              <div class="ewp-meta"><div class="ewp-brand">${esc(p.brand)}</div><div class="ewp-t">${esc(p.title)}</div>
              ${hasVar ? `<div class="ewp-variant"><label>Option</label><select data-variant data-step="${si}" data-i="${pi}" aria-label="${esc(p.title)} option">${p.variants.map((x, xi) => `<option value="${xi}" ${v === x ? "selected" : ""}>${esc(x.title)}</option>`).join("")}</select></div>` : ""}
              <div class="ewp-price">${priceHtml}</div></div></div>`;
          }).join("");
          body = (note ? `<p class="ewp-note">${note}</p>` : "") + `<div class="ewp-grid">${cards}</div>` +
            (s.optional ? `<button type="button" class="ewp-skip${done ? "" : " is-active"}" data-skip="${si}">${done ? "Remove from package" : "No thanks, skip this"}</button>` : "");
        }
        return `<section class="ewp-step${done ? " is-done" : ""}"><div class="ewp-step-head"><div class="ewp-num">0${si + 1}</div>
          <div><h2>${esc(s.label)}</h2><div class="ewp-sub">${esc(s.sub)}</div></div><span class="ewp-badge ${s.badge[0]}">${esc(s.badge[1])}</span></div>
          <div class="ewp-body">${body}</div></section>`;
      }).join("");
      summary();
    }

    const PASS = S.passes || {};
    function passFor(s) {
      const x = getSel(s); if (!x || !state.wing1) return null;
      if (s.key === "pump") return pct(s, x.p) !== S.pumpPct ? PASS.mini : PASS.pump;
      if (s.key === "leash") return PASS.leash;
      if (s.key === "harness") return S.harnessFree && state.wing2 ? PASS.harness : null;
      return null;
    }
    function summary() {
      let retail = 0, sub = 0, tot = 0, count = 0;
      q("[data-ewp-lines]").innerHTML = STEPS.map((s, si) => {
        const x = getSel(s);
        const k = `<span class="k">0${si + 1} · ${esc(s.label)}</span>`;
        if (!x) return `<div class="ewp-line">${k}<span class="empty">${s.optional ? "Not added" : "Not selected"}</span><span></span></div>`;
        const pk = pkgPrice(s, x.p, x.v); const rt = Math.max(x.v.compareAt || 0, x.v.price);
        retail += rt; sub += x.v.price; tot += pk; count++;
        const notes = [];
        if (rt > x.v.price) notes.push(`Sale price saves ${money(rt - x.v.price)}`);
        if (pk < x.v.price) notes.push(discLabel(s, x.p));
        const vt = isDefault(x.v.title) ? "" : " · " + esc(x.v.title);
        return `<div class="ewp-line">${k}<span>${esc(x.p.title)}${vt}</span><span class="p">${rt > pk ? `<s>${money(rt)}</s>` : ""}${pk === 0 ? "FREE" : money(pk)}</span>${notes.length ? `<span class="disc">${notes.join(" · ")}</span>` : ""}</div>`;
      }).join("");
      const passN = STEPS.filter(s => Number(passFor(s))).length, passC = passN * (S.passCents || 0);
      tot += passC; retail += passC; sub += passC;
      if (passC > 0) q("[data-ewp-lines]").insertAdjacentHTML("beforeend", `<div class="ewp-line ewp-line-pass"><span class="k">Checkout</span><span>Package discount pass${passN === 1 ? "" : "es"} (${passN})</span><span class="p">${money(passC)}</span></div>`);
      const neg = n => n > 0 ? "−" + money(n) : money(0);
      q("[data-ewp-tot]").innerHTML = `<div><span>Retail value (${count} ${count === 1 ? "item" : "items"})</span><span>${money(retail)}</span></div>
        <div class="save"><span>Sale price savings</span><span>${neg(retail - sub)}</span></div>
        <div class="save"><span>Package savings</span><span>${neg(sub - tot)}</span></div>
        <div class="grand"><span>Package total</span><span>${money(tot)}</span></div>
        ${retail - tot > 0 ? `<div class="ewp-total-save"><span>You save</span><span>${money(retail - tot)} (${Math.round((retail - tot) / retail * 100)}% off retail)</span></div>` : ""}`;
      const b = q("[data-ewp-add]");
      b.disabled = !state.wing1 || adding;
      b.textContent = adding ? "Adding package…" : state.wing1 ? "Add package to cart" : "Select your first wing";
    }

    async function addPackage() {
      if (!state.wing1 || adding) return;
      adding = true; summary();
      const status = q("[data-ewp-status]"); status.hidden = true; status.classList.remove("is-error");
      const pid = `wing-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`;
      const items = STEPS.map(s => { const x = getSel(s); return x ? { id: Number(x.v.id), quantity: 1, properties: { "_Wing Package ID": pid, "_Package Component": s.key } } : null; }).filter(Boolean);
      STEPS.forEach(s => { const id = Number(passFor(s)); if (id) items.push({ id, quantity: 1, properties: { "_Wing Package ID": pid, "_Package Component": s.key + "-pass" } }); });
      const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      try {
        const r = await fetch(rootPath + "cart/add.js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items }) });
        if (!r.ok) { const e = await r.json().catch(() => ({})); throw new Error(e.description || e.message || `Cart error ${r.status}`); }
        document.dispatchEvent(new CustomEvent("cart:add", { detail: { items, packageId: pid } }));
        window.location.assign(rootPath + "cart");
      } catch (e) {
        status.textContent = `The full package could not be added to the cart: ${e.message}. Check availability and your cart, then try again.`;
        status.classList.add("is-error"); status.hidden = false;
        adding = false; summary();
      }
    }

    function choose(si, pi) {
      const s = STEPS[si];
      if (s.key === "wing2" && state.wing1 && wings[state.wing1.i].id === s.items[pi].id) return;
      const cur = state[s.key];
      if (cur && cur.i === pi) { if (s.optional) state[s.key] = null; }
      else {
        const sel = root.querySelector(`select[data-variant][data-step="${si}"][data-i="${pi}"]`);
        state[s.key] = { i: pi, v: sel ? Number(sel.value) : 0 };
      }
      if (s.key === "wing1" && state.wing2 && wings[state.wing2.i].id === wings[state.wing1.i].id) state.wing2 = null;
      q("[data-ewp-status]").hidden = true;
      render();
    }

    root.addEventListener("click", e => {
      if (e.target.closest("select")) return;
      const skip = e.target.closest("[data-skip]");
      if (skip) { state[STEPS[Number(skip.dataset.skip)].key] = null; render(); return; }
      if (e.target.closest("[data-ewp-add]")) { addPackage(); return; }
      const card = e.target.closest(".ewp-card");
      if (card && !adding) choose(Number(card.dataset.step), Number(card.dataset.i));
    });
    root.addEventListener("keydown", e => {
      const card = e.target.closest(".ewp-card");
      if (card && (e.key === "Enter" || e.key === " ") && !e.target.closest("select")) { e.preventDefault(); choose(Number(card.dataset.step), Number(card.dataset.i)); }
    });
    root.addEventListener("change", e => {
      const sel = e.target.closest("select[data-variant]");
      if (!sel) return;
      const s = STEPS[Number(sel.dataset.step)];
      state[s.key] = { i: Number(sel.dataset.i), v: Number(sel.value) };
      render();
    });
    render();
  }
  function boot(scope) { (scope || document).querySelectorAll("[data-ewp-root]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => boot(), { once: true }); else boot();
  document.addEventListener("shopify:section:load", e => boot(e.target));
})();
